import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Box } from 'components/Grid';
import Image from 'components/Image';
import theme from 'utils/styles/theme';
import logo from '../../images/sultan-logo.svg';
import hypnosis from '../../images/hypnosis.svg';
import { spin } from 'utils/styles/animations';
import { navigate } from 'gatsby';

const HeaderStyled = styled(Box).attrs({
	as: 'header'
})`
	display: flex;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 10;

	filter: invert(${props => (props.inverted ? 1 : 0)});

	background-color: ${props => props.inverted && 'transparent'};

	> div,
	a {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		> img {
			margin-bottom: 0;
		}
	}

	.Header-Logo {
		background: none;
		border: 0;
		outline: none;
	}

	.Header-MenuButton {
		svg rect {
			transition: transform 0.4s ease;
			display: block;
		}

		&:hover {
			svg {
				pointer-events: none;
			}
			svg {
				rect:nth-child(even) {
					transform: translate3d(0, 0, 0) scaleX(0.8);
				}

				rect:nth-child(odd) {
					transform: translate3d(0, 0, 0) scaleX(1.2);
				}
			}
		}
	}
	.hypnosis-icon {
		${spin};
		&:hover {
			animation-play-state: paused;
		}
	}
`;
const Header = ({ toggleModal, invertedColors }) => {
	const onLogoClick = () => {
		toggleModal();
		navigate('/');
	};

	return (
		<HeaderStyled
			px={[3, '20px']}
			py={[1, 2]}
			height={theme.sizes.headerHeight}
			justifyContent="space-between"
			alignItems="center"
			inverted={invertedColors}
			bg="white"
		>
			<Box
				cursor={invertedColors ? 'pointerWhite' : 'pointer'}
				className="Header-MenuButton"
				onClick={() => toggleModal('menu')}
			>
				<svg width="31" height="26" xmlns="http://www.w3.org/2000/svg">
					<rect width="27" height="2" />
					<rect y="24" width="27" height="2" />
					<rect y="16" width="25" height="2" />
					<rect y="8" width="31" height="2" />
				</svg>
			</Box>
			<Box
				className="Header-Logo"
				as="button"
				cursor={invertedColors ? 'pointerWhite' : 'pointer'}
				onClick={onLogoClick}
			>
				<Image staticImg width={[120, 180]} src={logo} />
			</Box>
			<Box
				className="hypnosis-icon"
				cursor={invertedColors ? 'pointerWhite' : 'pointer'}
				onClick={() => toggleModal('hypnosis')}
			>
				<img src={hypnosis} />
			</Box>
		</HeaderStyled>
	);
};

Header.propTypes = {
	siteTitle: PropTypes.string,
	invertedColors: PropTypes.bool,
	toggleModal: PropTypes.func
};

Header.defaultProps = {
	siteTitle: ``
};

export default Header;
